<template>
  <transition name="fade">
    <div
      :class="[isTransparent ? 'header-transparent__2oKAE':'header-white','nav-box',]"
      style="min-width: 1700px;"
    >
      <img
        @click="goHome()"
        style="width:100px;cursor:pointer"
        src="../assets/hz-logo.png"
      >
      <el-menu
        :default-active="activeIndex"
        active-text-color="#0053AD"
        text-color="#333333"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item
          index="1"
          @click="goHome()"
        >首页</el-menu-item>
        <el-menu-item
          index="2-1"
          @click="goAbout('企业简介')"
        >走进弘知</el-menu-item>
        <el-menu-item
          index="3-1"
          @click="goCourse('课程设置')"
        >课程产品</el-menu-item>

        <el-menu-item
          index="4"
          @click="goTeacher()"
        >弘知师资</el-menu-item>

        <el-menu-item
          index="5-1"
          @click="goPhotoAlbum('多彩校区')"
        >弘知动态</el-menu-item>

        <el-menu-item
          index="6"
          @click="goJobFair()"
        >加入我们</el-menu-item>

      </el-menu>

    </div>
  </transition>

</template>

<script>
var s;
var control_ = 0;
export default {
  name: "navBar",
  props: {
    navIndex: String,
    imgHeight: Number,
  },
  data() {
    return {
      activeIndex: "1",
      show: true,
      isTransparent: true,
    };
  },
  mounted() {
    //   console.log('子组件',this.navIndex)
    this.activeIndex = this.navIndex;

    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    //上拉执行时滑动高度大于banner高度，导航颜色就是白色，否则就是透明
    handleTransparent(scrollTop) {
      if (scrollTop > this.imgHeight) {
        this.isTransparent = false;
      } else {
        this.isTransparent = true;
      }
    },
    handleScroll() {
      // 滚动条距文档顶部的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      control_ = control_ + 1;
      if (control_ === 1) {
        //保证这里只执行一次
        s = scrollTop;
        // console.log("s赋值执行");
      }

      if (scrollTop >= 0) {
        // 因为IOS端滑到顶了还可以继续往下扯
        // console.log(scrollTop);
        if (scrollTop - s > 70) {
          // this.show = false;
          //上拉执行时滑动高度大于banner高度，导航颜色就是白色，否则就是透明
          this.handleTransparent(scrollTop);
          s = scrollTop;
          // console.log("下拉执行", s); // 隐藏
        } else if (s - scrollTop > 70) {
          this.handleTransparent(scrollTop);

          // this.show = true;
          s = scrollTop;
          // console.log("上拉执行", s); // 显示
        }
      } else {
        this.show = true;
      }
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    goHome() {
      this.$router.push("/");
      //   this.activeIndex = "1"
    },
    //   关于弘知
    goAbout(e) {
      let that = this;
      // console.log(e);
      if (e === "企业简介") {
        // that.activeIndex = "2-1"
        that.$router.push({ name: "about", query: { type: "企业简介" } });
      } else if (e === "发展历程") {
        that.$router.push({ name: "about", query: { type: "发展历程" } });
      } else if (e === "弘知校区") {
        that.$router.push({ name: "about", query: { type: "弘知校区" } });
      }
    },
    //   课程产品
    goCourse(e) {
      let that = this;
      console.log(e);
      if (e === "课程设置") {
        that.$router.push({ name: "course", query: { type: "课程设置" } });
        //   that.activeIndex = "3-1"
      } else if (e === "科目介绍") {
        that.$router.push({ name: "course", query: { type: "科目介绍" } });
      } else if (e === "产品创新") {
        that.$router.push({ name: "course", query: { type: "产品创新" } });
      }
    },
    // 老师
    goTeacher() {
      this.$router.push({ name: "teacher" });
      this.activeIndex = "4";
    },
    // 人才招聘
    goJobFair() {
      this.$router.push({ name: "jobFair" });
      this.activeIndex = "6";
    },
    // 弘知相册
    goPhotoAlbum(e) {
      let that = this;
      if (e === "多彩校区") {
        that.$router.push({ name: "photoAlbum", query: { type: "多彩校区" } });
      } else if (e === "多趣工作") {
        that.$router.push({ name: "photoAlbum", query: { type: "多趣工作" } });
      } else if (e === "多样生活") {
        that.$router.push({ name: "photoAlbum", query: { type: "多样生活" } });
      } else if (e === "多维动态") {
        that.$router.push({ name: "photoAlbum", query: { type: "多维动态" } });
      }
    },
    // 弘知动态
    goDynamic() {
      this.$router.push({ name: "dynamic" });
    },
  },
};
</script>


<style scoped>
.nav-box {
  position: fixed;
  z-index: 111;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.el-menu.el-menu--horizontal {
  border: none;
}
/* 为了取消选中部分的下表横岗 */
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}

.el-menu--horizontal > .el-menu-item.is-active::after {
  content: "";
  display: block;
  height: 2px;
  position: absolute;
  width: 24px;
  left: calc(50% - 12px);
  bottom: -5px;
  /* background-color: rgb(0, 83, 173); */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
  bottom: 14px !important;
}

.el-menu--horizontal > .el-menu-item {
  transition: none;
  font-weight: 600;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none;
}
/* 为了取消选中部分的下表横岗-结束 */

:deep.el-menu-item.is-active,
:deep.el-submenu.is-active .el-submenu__title {
  font-weight: 600;
}

/* 导航背景透明效果 */
.header-transparent__2oKAE {
  backdrop-filter: none;
  background: transparent;
}

:deep.header-transparent__2oKAE .el-submenu__title,
:deep.header-transparent__2oKAE .el-menu-item {
  color: white !important;
  font-weight: 800;
}

.header-transparent__2oKAE
  .el-menu--horizontal
  .el-menu-item:not(.is-disabled):focus,
.header-transparent__2oKAE
  .el-menu--horizontal
  .el-menu-item:not(.is-disabled):hover {
  color: rgba(255, 255, 255, 0.5) !important;
}

:deep .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  background-color: transparent;
}

.header-transparent__2oKAE
  .el-menu--horizontal
  > .el-menu-item.is-active::after {
  background-color: white;
}

/* 导航背景透明效果 end*/

/* 导航背景为白色效果*/
.header-white {
  background: white;
}

.header-white .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.header-white .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: rgb(0, 83, 173) !important;
}

.header-white .el-menu--horizontal > .el-menu-item.is-active::after {
  background-color: rgb(0, 83, 173);
}

/* 导航背景为白色效果 end*/

:deep.el-menu {
  background-color: transparent;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>